import React from "react";
import { Helmet } from "react-helmet-async";
import { config } from "core/utils";
export var Meta = function (_a) {
    var data = _a.data;
    var pageTitle = data.pageTitle, program = data.program, title = data.title, description = data.description, url = data.url, imageUrl = data.imageUrl, ogType = data.ogType, type = data.type;
    var metaDescription = description || "Kleurt je dag";
    var metaTitle = getTitleAffix(title || pageTitle, type, program)
        ? getTitleAffix(title || pageTitle, type, program)
        : title || pageTitle;
    if (title === "The Masked Singer" && type === "Program")
        metaTitle = "The Masked Singer - Guessing Game";
    if (title === "Programmas")
        metaTitle = "Programma's";
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null, metaTitle),
            React.createElement("meta", { name: "title", content: metaTitle }),
            React.createElement("meta", { name: "description", content: metaDescription }),
            React.createElement("link", { rel: "canonical", href: url }),
            React.createElement("meta", { name: "twitter:title", content: metaTitle }),
            React.createElement("meta", { name: "twitter:description", content: metaDescription }),
            React.createElement("meta", { name: "twitter:site", content: config.meta.twitterHandle }),
            React.createElement("meta", { name: "twitter:image", content: imageUrl }),
            React.createElement("meta", { name: "twitter:card", content: config.meta.twitterCard }),
            React.createElement("meta", { property: "og:title", content: metaTitle }),
            React.createElement("meta", { property: "og:description", content: metaDescription }),
            React.createElement("meta", { property: "og:url", content: url }),
            React.createElement("meta", { property: "og:image", content: imageUrl }),
            React.createElement("meta", { property: "og:type", content: ogType }),
            React.createElement("meta", { property: "fb:app_id", content: config.meta.fbAppID }))));
};
function getTitleAffix(title, type, program) {
    switch (type) {
        case "Program":
            return "".concat(title, " - ").concat(config.meta.affixes.program);
        case "Contest":
            return program
                ? "".concat(config.meta.affixes.contest, " - ").concat(title, " - ").concat(program)
                : "".concat(config.meta.affixes.contest, " - ").concat(title);
        default:
            return program ? "".concat(title, " - ").concat(program) : undefined;
    }
}
